import React from 'react'

export type ModalHeaderProps = {
  title?: React.ReactNode
  buttonClasses?: string
  titleClasses?: string
  className?: string
  children?: React.ReactNode
}

export const ModalHeader = ({ title, ...props }: ModalHeaderProps) => (
  <header
    className={`w-full border-b flex justify-between items-center py-4 px-4 ${props.className}`}>
    <h2
      className={`sm:text-2xl flex items-center text-lg font-bold text-base-800 ${props.titleClasses}`}>
      {title}
    </h2>
  </header>
)
